import { render } from "./g-claims.vue?vue&type=template&id=0cd2df86&scoped=true"
import script from "./g-claims.vue?vue&type=script&lang=js"
export * from "./g-claims.vue?vue&type=script&lang=js"

import "./g-claims.vue?vue&type=style&index=0&id=0cd2df86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd2df86"]])

export default __exports__